// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__e0CPj","spinner":"Loader_spinner__UGp1l","spinner-d3wgkg":"Loader_spinner-d3wgkg__9HB8c"};